import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';
const endpoint = (branchId) => `${API_URL}/branch/${encodeURIComponent(branchId)}/display`;
const withAuth = ({ signal } = {}) => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
  ...(signal ? { signal } : {}),
});

const withReceivedClock = (display) => display?.promotionClock ? {
  ...display,
  promotionClock: { ...display.promotionClock, receivedAt: Date.now() },
} : display;

export const getBranchDisplay = async (branchId, options = {}) => withReceivedClock(
  (await axios.get(endpoint(branchId), withAuth(options))).data
);

export const saveBranchDisplay = async (branchId, payload) => withReceivedClock(
  (await axios.put(endpoint(branchId), payload, withAuth())).data
);

export const getBranchDisplayCatalog = async (branchId, params = {}, options = {}) => withReceivedClock(
  (await axios.get(`${endpoint(branchId)}/catalog`, { ...withAuth(options), params })).data
);

// A projection must stay anonymous even when opened beside an authenticated tab.
// Fetch bypasses the app's axios company interceptors; omit also excludes same-origin cookies.
const getPublicDisplayData = async (url, { signal } = {}) => {
  const response = await fetch(url, {
    credentials: 'omit',
    cache: 'no-store',
    headers: { Accept: 'application/json' },
    ...(signal ? { signal } : {}),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(data?.message || 'No se pudo cargar la pantalla.');
    error.response = { status: response.status, data };
    throw error;
  }
  return withReceivedClock(data);
};

export const getPublicBranchDisplay = (branchId, options) => getPublicDisplayData(`${endpoint(branchId)}/public`, options);
export const getPublicDisplayBranches = (options) => getPublicDisplayData(`${API_URL}/branch/display/public`, options);

export const getBranchScreens = async (branchId, options) => (await axios.get(`${endpoint(branchId)}/screens`, withAuth(options))).data;
export const createBranchScreen = async (branchId, name) => (await axios.post(`${endpoint(branchId)}/screens`, { name }, withAuth())).data;
export const createBranchScreens = async (branchId, count) => (await axios.post(`${endpoint(branchId)}/screens`, { count }, withAuth())).data;
export const removeBranchScreen = async (branchId, screenId) => (await axios.delete(`${endpoint(branchId)}/screens/${screenId == null ? 'default' : encodeURIComponent(screenId)}`, withAuth())).data;
export const getBranchScreen = async (branchId, screenId, options) => withReceivedClock((await axios.get(`${endpoint(branchId)}/screens/${encodeURIComponent(screenId)}`, withAuth(options))).data);
export const saveBranchScreen = async (branchId, screenId, payload) => withReceivedClock((await axios.put(`${endpoint(branchId)}/screens/${encodeURIComponent(screenId)}`, payload, withAuth())).data);
export const getPublicBranchScreen = (branchId, screenId, options) => getPublicDisplayData(`${endpoint(branchId)}/screens/${encodeURIComponent(screenId)}/public`, options);
